import React from 'react';
import MobileAppContainer from '@src/containers/MobileApp';
import MobileAppV2Container from '@src/containers/MobileAppV2';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { useSelector } from 'react-redux';
import { FEATURE_KEYS } from '@src/configs/featureKeys';

const MobileApp = () => {
  const user = useSelector((state) => state.auth.user);
  const { getFeatureValue } = useFeatureFlags();
  const useIntroduceMobileAppV2 = getFeatureValue(
    FEATURE_KEYS.INTRODUCE_NEW_MOBILE_APP,
    {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  return useIntroduceMobileAppV2 ? (
    <MobileAppV2Container />
  ) : (
    <MobileAppContainer />
  );
};

export default MobileApp;
